<header>
    <div class="text" mat-dialog-title>Test Audio and Video Settings</div>
    <button mat-icon-button class="header" (tapped)="close()">
        <app-icon [icon]="{ type: 'icon', class: 'material-icons', content: 'close' }"></app-icon>
    </button>
</header>
<mat-dialog-content>
    <main *ngIf="!show_feedback; else feedbacks">
        <div class="audio">
            <div class="label">Audio Settings</div>
            <div class="audio-devices">
                <mat-form-field appearance="outline">
                    <mat-select [(ngModel)]="audio_source">
                        <mat-option *ngFor="let device of audio_devices" [value]="device">
                            {{ device.label || 'Audio Input' }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="buttons" *ngIf="is_test_enabled">
                <button mat-button *ngIf="!isAudioPlaying" name="play-audio" (tapped)="testAudio()">
                    Test Microphone
                </button>
                <button mat-button *ngIf="isAudioPlaying" name="stop-audio" (tapped)="stopAudio()">
                    Stop Testing
                </button>
                <audio #audio></audio>
            </div>
            <div class="sub-text">Say something and you will hear a sound play back to you</div>
        </div>
        <div class="video">
            <div class="label">Video Settings</div>
            <div class="video-devices">
                <mat-form-field appearance="outline">
                    <mat-select [(ngModel)]="video_source">
                        <mat-option *ngFor="let device of video_devices" [value]="device">
                            {{ device.label || 'Video Input' }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="buttons" *ngIf="is_test_enabled">
                <button mat-button *ngIf="!isVideoPlaying" name="play-video" (tapped)="testVideo()">
                    Test Video
                </button>
                <button mat-button *ngIf="isVideoPlaying" name="stop-video" (tapped)="stopVideo()">
                    Stop Testing
                </button>
            </div>
            <div class="sub-text">Camera Preview</div>
            <div class="video-wrapper">
                <video #video height="240" width="320" playinline autoplay></video>
            </div>
        </div>
    </main>
    <ng-template #feedbacks>
        <div class="feedbacks">
            <div class="block">
                <div class="text">How was the sound ?</div>
                <div class="options">
                    <div
                        *ngFor="let option of audio_options"
                        [class]="'item ' + option.id"
                        [class.selected]="option === selected_audio"
                        (tapped)="selectAudio(option)"
                    >
                        <i class="material-icons">{{ option.icon }}</i>
                        <div class="sub-text">{{ option.label }}</div>
                    </div>
                </div>
            </div>
            <div class="block">
                <div class="text">How was the video ?</div>
                <div class="options">
                    <div
                        *ngFor="let option of video_options"
                        [class]="'item ' + option.id"
                        [class.selected]="option === selected_video"
                        (tapped)="selectVideo(option)"
                    >
                        <i class="material-icons">{{ option.icon }}</i>
                        <div class="sub-text">{{ option.label }}</div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</mat-dialog-content>
<mat-dialog-actions>
    <button
        mat-button
        class="success"
        *ngIf="!show_feedback; else finish"
        name="next"
        (tapped)="show_feedback = true"
    >
        Next
    </button>
    <ng-template #finish>
        <button mat-button class="error" (tapped)="show_feedback = false">Back</button>
        <button mat-button class="success" (tapped)="accept()">Finish</button>
    </ng-template>
</mat-dialog-actions>
